import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import 'vuetify/src/stylus/main.styl';
import '../stylus/main.styl';

Vue.use(Vuetify, {
    options: {
        customProperties: true
    },
    iconfont: 'md',
    theme: {
        primary: '#613da2',
        secondary: '#e0dede',
        accent: '#613da2',
        error: '#c12328',
        info: '#0091ff',
        success: '#88c123',
        warning: '#f7b500'
    }
});
